import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export let ChangeStatusThunk = createAsyncThunk(
    "/ChangeStatusThunk",
    async (arg, ThunkApi) => {
        // console.log(arg);
        let { rejectWithValue } = ThunkApi;
        try {
            let res = await axios.patch(`/api/change_status/${arg?.type}/${arg?.id}`, {
                status: arg?.active,
            });
            // console.log(res.data);

            return res.data;
        } catch (error) {
            console.log(error.response.data);
            return rejectWithValue(error.response.data);
        }
    }
);
